import React, { useState } from "react";

const CustomDropdown = ({ options, onSelect, register, name, errors }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        placeholder="Search country..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsOpen(true)}
        style={{
          outline: "none",
          border: "2px solid #e5e5e5",
          padding: "8px",
          width: "100%",
          marginBottom: "10px",
        }}
      />
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            border: "1px solid #e5e5e5",
            backgroundColor: "#fff",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                onClick={() => {
                  onSelect(option.id);
                  setSearchTerm(option.name);
                  setIsOpen(false);
                }}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #e5e5e5",
                }}
              >
                {option.name}
              </div>
            ))
          ) : (
            <div style={{ padding: "8px", color: "#999" }}>No country found</div>
          )}
        </div>
      )}
      <input
        type="hidden"
        {...register(name, { required: "Country is required" })}
        value={searchTerm}
      />
      {errors[name] && <p className="error">{errors[name].message}</p>}
    </div>
  );
};

export default CustomDropdown;